export const group_list = [
    {
        label: "Employee",
        value: "1"
    },
    {
        label: "Customer",
        value: "2"
    },
    {
        label: "Vendor",
        value: "3"
    }
]

export const status_resources = [
    {
        label: "Pending",
        value: "1"
    },
    {
        label: "On Progress",
        value: "2"
    },
    {
        label: "Hold",
        value: "3"
    },
    {
        label: "Completed",
        value: "4"
    }
]